export interface GaugeDefinition {
  id: string;
  label: string;
  format: (value: number) => string;
}

const formatKills = (value: number) => `${Math.round(value)} ${Math.round(value) === 1 ? "Kill" : "Kills"}`;

// One definition per registered gauge, in the order the API registers them.
export const GAUGES: GaugeDefinition[] = [
  { id: "most_ground_kills_in_sortie", label: "Most Ground Kills in Sortie", format: formatKills },
  { id: "most_armored_kills_in_sortie", label: "Most Armored Kills in Sortie", format: formatKills },
  { id: "most_sead_kills_in_sortie", label: "Most SEAD Kills in Sortie", format: formatKills },
  { id: "most_air_kills_in_sortie", label: "Most Air Kills in Sortie", format: formatKills },
  { id: "highest_speed_mach", label: "Top Speed", format: (value) => `Mach ${value.toFixed(2)}` },
  { id: "highest_altitude_ft", label: "Highest Altitude", format: (value) => `${Math.round(value).toLocaleString()} ft` },
  { id: "longest_missile_hit_nm", label: "Longest Missile Hit", format: (value) => `${value.toFixed(1)} nm` },
  { id: "longest_refuel_contact_seconds", label: "Longest Refuel Contact", format: (value) => `${Math.round(value)} Sec` },
  { id: "longest_sortie_distance_nm", label: "Longest Sortie Distance", format: (value) => `${value.toFixed(1)} nm` },
  { id: "longest_noe_distance_nm", label: "Longest NOE Distance", format: (value) => `${value.toFixed(1)} nm` },
];

export const GAUGE_BY_ID = new Map(GAUGES.map((gauge) => [gauge.id, gauge]));
